import { useEffect, useState } from 'react';
import { getProfile } from '../services/vendorAPI';
import { identifyUser } from '../utils/posthogProvider';
import { clearTokens } from '../utils/tokenUtils';
import { Crisp } from 'crisp-sdk-web';

const useCurrentUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setUser(null);
          setLoading(false);
          return;
        }

        // Verify token by fetching profile
        const response = await getProfile();
        if (response.success) {
          let userData = response.data;
          if (Array.isArray(userData)) {
            userData = userData[0];
          }

          if (userData) {
            setUser({
              uid: userData.id,
              email: userData.email,
              ...userData,
            });

            // Identify user in PostHog for restored sessions
            if (userData.email) {
              identifyUser(userData.email, {
                $email: userData.email,
                $name: userData.name,
                vendor_id: userData.id,
                email: userData.email,
                name: userData.name,
                country: userData.country,
              });

              // Set Crisp user data
              Crisp.user.setEmail(userData.email);
              if (userData.name) {
                Crisp.user.setNickname(userData.name);
              }
              Crisp.session.setData({
                vendor_id: userData.id,
                country: userData.country,
              });
            }
          } else {
            // Handle case where data is empty/invalid
            setUser(null);
          }
        } else {
          // Token invalid — clear both tokens
          clearTokens();
          setUser(null);
        }
      } catch (err) {
        setError(err);
        setUser(null);
        clearTokens();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { user, loading, error };
};

export default useCurrentUser;
